import ReactGA from 'react-ga';

const trackEvent = (options)=> {
  ReactGA.event(options);
}

const trackTiming = () => {}

const trackPageView = () => {}

const trackException = ({description, fatal = true, apiError = false, statusCode}) => {
  if(apiError) {
    trackAPIError({statusCode});
  }
  ReactGA.exception({
    description,
    fatal,
  });
}

const trackAPIError = ({statusCode}) => {
  if(window.dataLayer) {
    window.dataLayer.push({
      apiError: {statusCode},
      event: 'apiError'
    })
  }
}

export default {
  trackException,
  trackPageView,
  trackTiming,
  trackEvent,
  trackAPIError
}
